import {MessageService} from '@services';
import {BaseFirebaseModel} from '../bases/baseFirebaseModel';
import {Message} from './Message';
import {Profile} from '../User/Profile';


export class Room extends BaseFirebaseModel {

	lang: string = 'en';
	title = 'New Tchat Room';
	description = '';
	messages: Message[] = [];
	members: string[] = [];
	membersProfiles: Profile[] = [];
	isPrivate = false;
	img: string = Profile.defaultImg;
	order: number = 0;
	mention: number = 0;
	name: string = '';
	public soloMember: Profile = new Profile();
	public newMessage: number = 0;
	selected: boolean = false;
	private initValue?: Room;
	private init: boolean = true;

	constructor(obj?: Record<string, unknown>) {
		super();
		if (!this.init) {
			this.init = false;
		} else {
			Object.assign(this, obj);
		}
		if (!this.img) {
			this.img = Profile.defaultImg;
		}
	}

	getMessages(messageService: MessageService, startAt?: Date) {
		return messageService.getMessagesByRoom(this, startAt);
	}

	async sendMessage(msg: Message, messageService: MessageService) {
		return await messageService.sendMessage(this, msg);
	}

	getMessagesObserver(messageService: MessageService) {
		return messageService.getMessageObserver(this);
	}

	realtimeUpdate() {
		const updates = new Map();
		const basePath = '/rooms/' + this.uuid + '/';
		const nullobj = {};
		if (!this.initValue) {
			return nullobj;
		} else {
			if (this.initValue.description !== this.description && this.description !== undefined) {
				updates.set(basePath + 'description', this.description);
			}
			if (this.initValue.img !== this.img && this.img !== undefined && this.img !== Profile.defaultImg) {
				updates.set(basePath + 'img', this.img);
			}
			if (this.initValue.isPrivate !== this.isPrivate && this.isPrivate !== undefined) {
				updates.set(basePath + 'isPrivate', this.isPrivate);
			}
			if (this.initValue.lang !== this.lang && this.lang !== undefined) {
				updates.set(basePath + 'lang', this.lang);
			}
			if (this.initValue.members.length !== this.members.length) {
				updates.set(basePath + 'members', this.members);
			}
			if (this.initValue.order !== this.order && this.order !== undefined) {
				updates.set(basePath + 'order', this.order);
			}
			if (this.initValue.title !== this.title && this.title !== undefined) {
				updates.set(basePath + 'gender', this.title);
			}
			if (this.initValue.name !== this.name && this.name !== undefined) {
				updates.set(basePath + 'name', this.name);
			}
		}
		// @ts-expect-error - Type assertion needed for Map to object conversion
		return updates !== nullobj ? <object> [...updates].reduce((o, [key, value]) => (o[key] = value, o), {}) : false;
	}


	override toFirebase() {
		const bfm = JSON.parse(JSON.stringify({
			                                      description: this.description,
			                                      img: this.img,
			                                      isPrivate: this.isPrivate,
			                                      lang: this.lang,
			                                      members: this.members,
			                                      name: this.name,
			                                      private: this.isPrivate,
			                                      title: this.title
		                                      }));
		delete bfm.id;
		return bfm;
	}
}
